// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Belt_HashMapString = require("rescript/lib/js/belt_HashMapString.js");

function markUrlAsTrusted(settings, url) {
  if (Belt_Option.isSome(Caml_option.undefined_to_opt(settings.webSrcSettings.find(function (ws) {
                  return ws.url === url;
                })))) {
    return {
            parens: settings.parens,
            asrtsToSkip: settings.asrtsToSkip,
            asrtsToSkipRegex: settings.asrtsToSkipRegex,
            editStmtsByLeftClick: settings.editStmtsByLeftClick,
            defaultStmtType: settings.defaultStmtType,
            defaultStmtLabel: settings.defaultStmtLabel,
            initStmtIsGoal: settings.initStmtIsGoal,
            checkSyntax: settings.checkSyntax,
            stickGoalToBottom: settings.stickGoalToBottom,
            typeSettings: settings.typeSettings,
            webSrcSettings: settings.webSrcSettings.map(function (ws) {
                  if (ws.url === url) {
                    return {
                            alias: ws.alias,
                            url: ws.url,
                            trusted: true
                          };
                  } else {
                    return ws;
                  }
                }),
            longClickEnabled: settings.longClickEnabled,
            longClickDelayMs: settings.longClickDelayMs,
            hideContextSelector: settings.hideContextSelector,
            showVisByDefault: settings.showVisByDefault,
            editorHistMaxLength: settings.editorHistMaxLength
          };
  } else {
    return {
            parens: settings.parens,
            asrtsToSkip: settings.asrtsToSkip,
            asrtsToSkipRegex: settings.asrtsToSkipRegex,
            editStmtsByLeftClick: settings.editStmtsByLeftClick,
            defaultStmtType: settings.defaultStmtType,
            defaultStmtLabel: settings.defaultStmtLabel,
            initStmtIsGoal: settings.initStmtIsGoal,
            checkSyntax: settings.checkSyntax,
            stickGoalToBottom: settings.stickGoalToBottom,
            typeSettings: settings.typeSettings,
            webSrcSettings: settings.webSrcSettings.concat([{
                    alias: "",
                    url: url,
                    trusted: true
                  }]),
            longClickEnabled: settings.longClickEnabled,
            longClickDelayMs: settings.longClickDelayMs,
            hideContextSelector: settings.hideContextSelector,
            showVisByDefault: settings.showVisByDefault,
            editorHistMaxLength: settings.editorHistMaxLength
          };
  }
}

function settingsGetTypeColors(settings) {
  return Belt_HashMapString.fromArray(settings.typeSettings.map(function (ts) {
                  return [
                          ts.typ,
                          ts.color
                        ];
                }));
}

exports.markUrlAsTrusted = markUrlAsTrusted;
exports.settingsGetTypeColors = settingsGetTypeColors;
/* No side effect */
